import React from 'react';
import { RFC } from 'shared/types/sharedTypes';
import { ResetPasswordForm } from 'shared/components/ResetPasswordForm';
import { adminApiManager } from '../../network/apiManager';
import { NonAuthRouteNames } from '../../navigation/routeNames';
import styled from 'styled-components';
import { PageContainer } from '../../components/Wrappers';
import { BackToLink } from 'shared/components/Links';

export const ResetPassword: RFC = () => {
    return (
        <PageContainer>
            <BackToLink path={NonAuthRouteNames.Login} text={'Return to Login'} />
            <FormContainer>
                <ResetPasswordForm apiManager={adminApiManager} redirectPath={NonAuthRouteNames.Login} />
            </FormContainer>
        </PageContainer>
    )
}

const FormContainer = styled.div`
  width: 50%;
  margin: 0 auto;
  text-align: center;
`;